module.exports = __webpack_public_path__ + "img/estudiantes_nuevos.a0b27da5.png";